import React from 'react';
// Original icons are not used, steps will be numbered.
// Original step titles/descriptions from index.html were different and only 3 steps.
// Retaining 5 steps from this component's data for now, but styling them like the original.
const steps = [
  {
    // title: "1. Discovery Call", // Number will be generated from index
    title: 'Discovery Call',
    description:
      "We'll discuss your dealership's unique needs and goals to tailor our solution for you.",
  },
  {
    title: 'Custom Setup',
    description:
      "Our team will set up your account and customize it to match your dealership's branding and workflow.",
  },
  {
    title: 'Training & Onboarding',
    description:
      "We'll train your team on how to use LiveFunnel effectively to maximize your results.",
  },
  {
    title: 'Launch & Optimize',
    description: 'Go live with your new funnels and start converting more leads into customers.',
  },
  {
    title: 'Ongoing Support',
    description: 'Our team is here to provide continuous support and optimization recommendations.',
  },
];

const Process = () => {
  return (
    <section className="py-[100px] bg-gray-50" id="process">
      <div className="container mx-auto px-4">
        <div className="text-center mb-[60px]">
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">How We Deliver Results</h2>
          <p className="text-lg text-gray max-w-[700px] mx-auto">
            Our proven 5-step process ensures your dealership gets the most out of LiveFunnel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white p-[30px] rounded-lg shadow-lg text-center hover:shadow-xl hover:-translate-y-2.5 transition-all duration-300"
            >
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-5 font-bold text-xl">
                {index + 1}
              </div>
              <h3 className="text-xl font-semibold text-dark mb-2.5">{step.title}</h3>
              <p className="text-base text-gray leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#contact"
            className="inline-block px-8 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors duration-300"
          >
            Schedule a Call
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;
